"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var ModalV2_1 = __importDefault(require("@src/components/ModalV2"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var AuditLogs_1 = require("@src/utils/AuditLogs");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var BotActions_1 = require("@src/actions/BotActions");
var _utils_1 = require("@src/actions/_utils");
var const_1 = require("@src/const");
var api_1 = require("@src/api");
var utils_1 = require("./utils");
require("./TransferModal.scss");
/**
 * A modal which will be shown when user taps on transfer button. Users can use this modal to start augmentation process
 * or to transfer bot. Augmentation is a process through which machine learning module inserts additional
 * user says(backend term "Paraphrase", UI term "Smart Variant") in the bot to make it more smarter. These additional
 * user says will be then shown in the User Says tab of a specific node or connection under the label "Smart Variants".
 */
var TransferModal = function (_a) {
    var active = _a.active, isAugmentationInProgress = _a.isAugmentationInProgress, domain = _a.domain, onClose = _a.onClose, onAugmentationStart = _a.onAugmentationStart, botVersioningEnabled = _a.botVersioningEnabled, onTransferStart = _a.onTransferStart, showPreview = _a.showPreview;
    var _b = react_1.useState(), botSummaryData = _b[0], setBotSummaryData = _b[1];
    var _c = react_1.useState(false), fetchingBotSummary = _c[0], setFetchingBotSummary = _c[1];
    var isSuperman = _utils_1.isNewPipeline(domain);
    var isAugmentationAvailable = react_1["default"].useCallback(function () {
        return isSuperman && botSummaryData && botSummaryData.paraphraseSupported && botSummaryData.paraphrasesCount > 0;
    }, [botSummaryData, isSuperman]);
    /**
     * This API call fetch details of bot and augmentation status.
     */
    var fetchSummary = react_1["default"].useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, botSummary, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setFetchingBotSummary(true);
                    return [4 /*yield*/, BotActions_1.getBotSummary(domain.id)];
                case 1:
                    data = _a.sent();
                    if (!data) {
                        BotActions_1.createAlert('Unable to fetch bot data', undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
                        onClose();
                    }
                    botSummary = {
                        stories: data.story.stories,
                        integrationConfig: data.domain.integration_config,
                        paraphraseSupported: data.paraphrases_details.paraphrases_supported,
                        paraphrasesCount: data.paraphrases_details.count
                    };
                    if (botSummary.paraphraseSupported && botSummary.paraphrasesCount > 0) {
                        _utils_1.sendGoogleAnalyticsEvents(const_1.GOOGLE_ANALYTICS.CATEGORY.SMART_VARIANTS, const_1.GOOGLE_ANALYTICS.EVENTS.SMART_VARIANTS_AVAILABLE, "domain-" + domain.title, const_1.GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK);
                    }
                    setBotSummaryData(botSummary);
                    setFetchingBotSummary(false);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    api_1.captureException(e_1);
                    BotActions_1.createAlert('Unable to fetch bot data', undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
                    onClose();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [domain, onClose]);
    react_1.useEffect(function () {
        if (active) {
            if (!botSummaryData && !isAugmentationInProgress) {
                // Only fetch summary data prior to aumentation process
                fetchSummary();
            }
        }
        else {
            // When hiding modal set null, so that we refetch fresh summary data whenever modal is active next time.
            setBotSummaryData(null);
        }
    }, [active, botSummaryData, isAugmentationInProgress, fetchSummary]);
    /**
     * This method triggers the bot augmentation process.
     */
    var startAugmentation = react_1["default"].useCallback(function () {
        var domainName = domain.title.toLowerCase();
        var headers = AuditLogs_1.getAuditHeaders({
            domain: domain,
            eventName: 'train_bot',
        });
        BotActions_1.startBotAugmentation(domainName, headers);
        onAugmentationStart();
    }, [domain, onAugmentationStart]);
    var checkBaseUrl = function () {
        if (!botSummaryData)
            return false;
        var values = Object.values(botSummaryData.integrationConfig);
        var isBaseURLDefined = values.length
            ? values.reduce(function (acc, val) {
                acc = acc && !!val;
                return acc;
            }, true)
            : false;
        var relativeIntegrations = botSummaryData.stories.reduce(function (acc, story) {
            var relativeIntegration = story.relative_path_integrations.length;
            if (relativeIntegration) {
                acc = __spreadArrays(acc, [{ name: story.story_name, relativeIntegration: relativeIntegration }]);
            }
            return acc;
        }, []);
        return !isBaseURLDefined && relativeIntegrations.length > 0;
    };
    /**
     * This method triggers the bot transfer.
     */
    var handleTransfer = react_1["default"].useCallback(function () {
        var headers = AuditLogs_1.getAuditHeaders({
            domain: domain,
            eventName: 'bot_transfer',
        });
        if (isAugmentationAvailable()) {
            // If count is > 0, that means user opted to transfer bot without choosing augmentation.
            _utils_1.sendGoogleAnalyticsEvents(const_1.GOOGLE_ANALYTICS.CATEGORY.SMART_VARIANTS, const_1.GOOGLE_ANALYTICS.EVENTS.TRANSFER_WITHOUT_SMART_VARIANTS, "domain-" + domain.title, const_1.GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK);
        }
        BotActions_1.transferBot({
            domain_id: domain.title,
            headers: headers,
        }, domain);
        onTransferStart();
    }, [domain, onTransferStart, isAugmentationAvailable]);
    /**
     * Render footer.
     */
    var renderFooter = react_1["default"].useCallback(function () {
        return (react_1["default"].createElement(box_1["default"], { p: "0", pt: 32 },
            isAugmentationAvailable() && (
            // Show add smart variant button only when paraphrase count is greator than 0
            react_1["default"].createElement(button_1["default"], { size: "large", type: "text", className: "leftBtn", onClick: startAugmentation }, "Add Smart Variants")),
            botVersioningEnabled && (
            // Show preview transfer button if feature enabled
            react_1["default"].createElement(button_1["default"], { onClick: showPreview, className: "transferBtn", size: "large", type: "text", variant: "secondary", themed: true }, "View Preview")),
            react_1["default"].createElement(button_1["default"], { onClick: handleTransfer, size: "large", type: "text", themed: true }, "Publish Now")));
    }, [isAugmentationAvailable, botVersioningEnabled, startAugmentation, handleTransfer]);
    var isBaseUrlMissing = checkBaseUrl();
    var noStoryAdded = botSummaryData ? botSummaryData.stories.length < 1 : false;
    var _d = utils_1.getTitleAndBody(noStoryAdded, isBaseUrlMissing, fetchingBotSummary, isAugmentationInProgress, botSummaryData, isSuperman), title = _d.title, body = _d.body;
    var showLoader = isAugmentationInProgress || fetchingBotSummary;
    // Don't render footer if base url is missing or if no story added
    var hideFooter = isBaseUrlMissing || noStoryAdded;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(ModalV2_1["default"], { title: "", subtitle: "", headerIcon: null, headerSubIcon: null, active: active, classPrefix: "confirmTransferModal", isV2: true, toggleModal: onClose },
            react_1["default"].createElement("div", { className: "confirmTransferModalBody" },
                react_1["default"].createElement(text_1["default"], { className: "confirmTransferModalBodyTitle", variant: "h2.semi-bold" }, title),
                react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.deep" }, body),
                showLoader ? (
                // Render loader view if aumgemtation or bot summary API call is in progress.
                react_1["default"].createElement(loader_1["default"], { className: "loader", size: 50 })) :
                    !hideFooter && renderFooter()))));
};
exports["default"] = TransferModal;
